import { QRCodeCanvas } from "qrcode.react";
import { forwardRef, useEffect, useState } from 'react';
import { FaBan, FaEdit, FaPrint, FaUnlock } from 'react-icons/fa';
import CommonButton from '../components/CommonButton';
import '../styles/MemberCard.css';
import { getPhotoUrl } from '../services/utils/supabaseUtils';

const MemberCard = forwardRef(({ member, onEdit, onPrint, onBlock, onUnblock, isActive = 1, showActions = 0, isUnblocking }, ref) => {
  const [photoURL, setPhotoURL] = useState('/assets/photo-profile/profile.png');
  const active = !!isActive;
  const [flipped, setFlipped] = useState(false);
  const formatMemberName = (fullName, maxLength = 26) => {
    if (!fullName) return "";

    let words = fullName.trim().split(/\s+/);

    // Capitalize normal name look
    words = words.map((w, i) =>
      i === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1)
    );

    let result = [...words];
    
    // Jika masih muat → return langsung
    if (result.join(" ").length <= maxLength) {
      return result.join(" ");
    }

    // ✅ Tetap semua FULL dulu, baru pangkas dari belakang
    for (let i = result.length - 1; i > 0; i--) {
      if (result.join(" ").length <= maxLength) break;
      
      const w = result[i];

      // Jika angka → biarkan
      if (/^\d+$/.test(w)) continue;

      // Ubah jadi huruf awal kapital
      result[i] = w.charAt(0).toUpperCase();
    }

    return result.join(" ");
  };

  const displayName = formatMemberName(member?.full_name);

  useEffect(() => {
    const fetchPhoto = async () => {
      const url = await getPhotoUrl(member?.photo);
      setPhotoURL(url);
    };

    fetchPhoto();
  }, [member?.photo]);

  return (
    <div ref={ref}>
      <div className={`member-card-container ${!active ? "blocked" : ""} card-flip-wrapper ${flipped ? 'flipped' : ''}`} onClick={() => setFlipped(!flipped)}>
        <div className="member-card">
          <img className="member-photo" src={photoURL} />
          <div className="member-info">
            <span>{member?.member_id}</span>
            <span>{displayName}</span>
          </div>
        </div>
        <div className="member-card-back">
          <img className="member-background" src="/assets/logo-back.png"/>
          <div className="member-qrcode">
            <QRCodeCanvas value={member.member_id + "_" + member.full_name} size={60} />
          </div>
          <div className="backcard-text">
            <span className="backcard-text-header">Budaya KSN : Mettā & Pañcabala</span>
            <span className="backcard-text-top">Kami, Praktisi Dhamma dan Sukarelawan KSN, bersama melayani dan melakukan Kebajikan dengan berpedoman Mettā dan Pañcabala.</span>
            <div className="backcard-text-wrapper">
              
              <ol start="1" className="backcard-text-items">
                <li>Mengedepankan pelayanan dengan cinta kasih kepada siapapun, demi kebahagiaan dan kesejahteraan bersama (Mettā).</li>
                <li>Yakin untuk berbuat baik dengan tulus dan tanpa pamrih (Saddhā).</li> 
                <li>Penuh semangat dan antusias untuk bersumbangsih dan terus berkembang menjadi pribadi yang lebih baik (Viriya).</li>
                <li>Selalu sadar dan sepenuh hati akan peranan yang dilakukan, sekecil apapun, adalah untuk perkembangan Buddhasāsana (Sati).</li>
                <li>Fokus pada tugas yang diemban dan berdedikasi penuh dalam melaksanakannya (Samādhi).</li>
                <li>Bijaksana dalam berpikir, berucap, dan bertindak agar menjadi panutan dan inspirasi bagi sesama (Paññā).</li>
              </ol>
            </div>
            <span className="backcard-text-footer">Tumbuh Setiap Saat <br/> Menjadi Tercerahkan dan Sempurna</span>
          </div>
        </div>
        <div className="member-card-back-full">
          <div className="member-qrcode">
            <QRCodeCanvas value={member.member_id + "_" + member.full_name} size={60} />
          </div>
          <div className="backcard-text">
            <span className="backcard-text-header">Budaya KSN : Mettā & Pañcabala</span>
            <span className="backcard-text-top">Kami, Praktisi Dhamma dan Sukarelawan KSN, bersama melayani dan melakukan Kebajikan dengan berpedoman Mettā dan Pañcabala.</span>
            <div className="backcard-text-wrapper">
              
              <ol start="1" className="backcard-text-items">
                <li>Mengedepankan pelayanan dengan cinta kasih kepada siapapun, demi kebahagiaan dan kesejahteraan bersama (Mettā).</li>
                <li>Yakin untuk berbuat baik dengan tulus dan tanpa pamrih (Saddhā).</li> 
                <li>Penuh semangat dan antusias untuk bersumbangsih dan terus berkembang menjadi pribadi yang lebih baik (Viriya).</li>
                <li>Selalu sadar dan sepenuh hati akan peranan yang dilakukan, sekecil apapun, adalah untuk perkembangan Buddhasāsana (Sati).</li>
                <li>Fokus pada tugas yang diemban dan berdedikasi penuh dalam melaksanakannya (Samādhi).</li>
                <li>Bijaksana dalam berpikir, berucap, dan bertindak agar menjadi panutan dan inspirasi bagi sesama (Paññā).</li>
              </ol>
            </div>
            <span className="backcard-text-footer">Tumbuh Setiap Saat <br/> Menjadi Tercerahkan dan Sempurna</span>
          </div>
        </div>
      </div>
      {
      showActions ? (
        active ? (
          <div className="member-actions">
            <button className="member-actions-button" onClick={() => onEdit(member)}><FaEdit /></button>
            <button className="member-actions-button" onClick={() => onPrint(member)}><FaPrint /></button>
            <button className="member-actions-button" onClick={() => onBlock(member)}><FaBan /></button>
          </div>
        ) : (
          <div className="member-actions">
            <CommonButton className="button-unblockir" loading={isUnblocking} onClick={() => onUnblock(member)}><FaUnlock/> Unblockir</CommonButton>
          </div>
        )
      ) : null}
    </div>
  );
});

export default MemberCard;
